var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Banner'),_c('v-container',[_c('CustomerSummary')],1),_c('v-container',{staticClass:"pt-0"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }